import React, { useRef, useEffect } from 'react';
import qs from 'qs';
import { CheckboxToggleRefinement } from './CheckboxToggleRefinement';
import { useToggleRefinement } from 'react-instantsearch';
import { updateSearchRefFromUrl } from '../utils';
import type { SearchState } from '../../collections/searchStateUrlStorageHelpers';

interface CheckboxClearanceItemsProps {
  label: string;
  setIsClearanceItemsRefined: React.Dispatch<React.SetStateAction<boolean>>;
  nbClearanceItems: number;
}

const CheckboxClearanceItems = ({
  label,
  setIsClearanceItemsRefined,
  nbClearanceItems,
}: CheckboxClearanceItemsProps) => {
  const { value, refine } = useToggleRefinement({ attribute: 'banner_tags.label', on: 'Clearance' });

  const isCurrentRefinement = !!value?.isRefined;
  const searchState = qs.parse(window.location.search.slice(1)) as SearchState;
  const searchRef = useRef(searchState);

  useEffect(() => {
    setIsClearanceItemsRefined(isCurrentRefinement);
  }, [isCurrentRefinement]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isCurrentRefinement = event.target.checked;

    refine({ isRefined: !isCurrentRefinement });

    updateSearchRefFromUrl(searchRef);
  };

  if (nbClearanceItems === 0) return null;

  return (
    <CheckboxToggleRefinement
      label={label}
      isChecked={isCurrentRefinement}
      onChange={onChange}
      count={nbClearanceItems}
      id="clearanceItemsRefinement"
    />
  );
};

export default CheckboxClearanceItems;
